import { Component, Directive, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/_services/data.service';
// import { NgInitDirectiveDirective } from '../../_core/_directive/ng-init-directive.directive';
import { map, filter } from 'rxjs/operators';
import { TestBed } from '@angular/core/testing';

@Component({
  selector: 'app-search-projects',
  templateUrl: './search-projects.component.html',
  styleUrls: ['./search-projects.component.scss']
})

export class SearchProjectsComponent implements OnInit {
  categories: { title: string; list: any; }[] = [];
  @Input() public projects = new EventEmitter();
  @Input() public compositeDesign = new EventEmitter();
  @Input() public unika = new EventEmitter();
  @Input() public searchGeneralLook = new EventEmitter();
  @Input() public showProperties = new EventEmitter();
  @Output() public showSearchResults = new EventEmitter();
  searchTerm;
  ifShowProperties: boolean = false;
  buildingTitle: string = "";
  freeStatusCounter: number = 0;
  waitingStatusCounter: number = 0;
  soldStatusCounter: number = 0;
  urlSwitcher: any;

  constructor(public dataService: DataService, private router: Router, private route: ActivatedRoute,) { }

  ngOnInit(): void {
    this.urlSwitcher = this.dataService.wichDesign().urlSwitcher;



    let projects = [];

    setTimeout(() => {
      test(this.projects);
      function test(proj) {
        projects = proj;
      }
      if (this.showProperties) {
        let addBuilding =  (proj => {
          this.dataService.getItemsByProjId(proj.id).subscribe(buildList => {
            proj.buildings = [];
            console.log(buildList);
            if (buildList.length > 0) {
              let statusCounter = this.getFlats(buildList);
              proj.statusCounter = statusCounter;
              proj.buildings = buildList;
            }
          })
        })

        projects.map((proj, index) => {
          addBuilding(proj);
        });

        this.addCategoryTitles(projects);

      } else {
        this.addCategoryTitles(this.projects);

      }
    }, 500);
  }

  getFlats(buildings) {      
    interface StatusCounter {
      free: number;
      waiting: number;
      sold: number;
    };
    let statusCounter: StatusCounter = {free: 0, waiting: 0, sold: 0};
    let numberOfRoomsArray: any=[];
    const results = buildings.map((building) => {
      this.buildingTitle = building.name;
      return building.floors.map(item => {
        return item.floor.flats.filter((flat) => {
          flat.buildingName = building.name;
          // if (!this.airDirectionArray.includes(flat.airDirection)) {
          //   if (flat.airDirection && flat.airDirection !== "") {
          //     this.airDirectionArray.push(flat.airDirection);
          //   }
          // }
          // if (!this.numberOfRoomsArray.includes(+flat.numberOfRooms)) {
          //   if (flat.numberOfRooms > 0 && flat.numberOfRooms) {
          //     this.numberOfRoomsArray.push(+flat.numberOfRooms);
          //     this.numberOfRoomsArray.sort(function (a, b) {
          //       return a - b;
          //     });
          //   }
          //   // return flat.airDirection;
          // }
          // let index = numberOfRoomsArray.includes(flat.numberOfRooms+"");


          // const index = numberOfRoomsArray.filter((num, index) => num.numRoomTitle === flat.numberOfRooms);

          // let numberOfRoomsTitle = flat.numberOfRooms+"";
          // if (index.length <= 0) {
          //   numberOfRoomsArray.push({numRoomTitle: numberOfRoomsTitle, 'counter': 1})
          // } else {
          //   index[0].counter = index[0].counter + 1
          // }

          
          if (flat.status !== "") {
            if (flat.status === 'free') {
              this.freeStatusCounter = this.freeStatusCounter + 1;
              statusCounter.free = statusCounter.free + 1;
            }
            if (flat.status === 'waiting') {
              this.waitingStatusCounter = this.waitingStatusCounter + 1;
              statusCounter.waiting = statusCounter.waiting + 1;
            }
            if (flat.status === 'sold') {
              this.soldStatusCounter = this.soldStatusCounter + 1;
              statusCounter.sold = statusCounter.sold + 1;
            }
          }

          // if (!this.statusArray.includes(flat.status)) {
          //   if (flat.status !== "") {
          //     this.statusArray.push(flat.status);
          //   }

          // }
          return false;
        });
      })
    });
    console.log(numberOfRoomsArray);
    return  statusCounter;
  }

  addCategoryTitles(projects) {

    if (projects) {
      const categoryWithProjects = projects.reduce((acc, proj) => {
        if (!acc[proj.category]) {
          acc[proj.category] = [];
        }
        acc[proj.category].push(proj);
        return acc;
      }, {});

      const categoryWithProjectsArray = Object.keys(categoryWithProjects).map(title => ({
        title: title,
        list: categoryWithProjects[title]
      }))

      this.categories = categoryWithProjectsArray;
    }

  }


  viewItemDetails(event, item) {
    const segment = this.route.snapshot.url;
    // this.ifCompositeDesign(segment);
    // this.router.navigate(['/company/' + this.route.snapshot.params.id + '/' + item.uid + '/test'] );
    let link:string;
    if(this.route.snapshot.params.id) {
      link = this.urlSwitcher + this.route.snapshot.params.id + '/' + item.uid;
    } else {
      link = this.urlSwitcher + this.route.snapshot.children[0].params.id + '/' + item.uid;
    }
    // let link = "";
    // if (this.compositeDesign && !this.unika) {
    //   // this.router.navigate(['/company/n/' + this.route.snapshot.params.id + '/' + item.uid]);
    //   link = '/company/n/' + this.route.snapshot.params.id + '/' + item.uid;
    // } else if(this.unika) {
    //   link = '/company/u/' + this.route.snapshot.params.id + '/' + item.uid; 
    // } else {
    //   // this.router.navigate(['/company/' + this.route.snapshot.params.id + '/' + item.uid]);
    //   link = '/company/' + this.route.snapshot.params.id + '/' + item.uid; 
    // } 

    this.dataService.openProjectClickOnMarker(item);
    this.dataService.saveRemoveMenu('false');


    
    window.open(link, '_blank')
  }
  showResoultBlock() {
    this.showSearchResults.emit('true');
  }
  closeSearch() {
    this.showSearchResults.emit('false');
  }
  goToBuilding(buildingUid, project){
    this.dataService.saveRemoveMenu('false');
    const link = '/company/u/' + this.route.snapshot.params.id + '/' + project.uid + '/building/' + buildingUid
    window.open(link, '_blank')
  }
}
